export const USER_ROLE = {
    salesRepresentative: 'Sales Rep',
    LSA: 'LSA',
    Instructor: 'Instructor',
    ProjectSpecialist:'Project Specialist'
};

export const ETEXT_STATUSES = {
    PRODUCT_CREATION: 'Product Record sent to PDZ:',
    INITIAL_CONTENT_PROCESSING: 'PDF sent to eText Optimization:',
    CONTENT_PROCESS_STATUS: 'CITE TOC Manifest received:',
    CONTENT_PUBLISH_MSG: 'CITE TOC Manifest sent to CSG and PLA:',
    INDEX_BUILD_COMPLETED: 'CSG Indexed for In-content Search:',
    SEED_COMPLETED: 'PLA data ready for instructor Dashboard:',
    INSTANT_PURCHASE_OFFER: 'Instant Purchase Offer Created:',
    INVITE_EMAIL: 'Instructor Invite Email Ready to be Sent:'
};

export const VITALSOURCE_STATUSES = {
    VITALSOURCE_BOOK_INITIALIZED: 'Vitalsource book creation initiated:',
    BOOKBUILD_STATUS: 'Vitalsource book build status:',
    VITALSOURCE_ACKNOWLEDGEMENT: 'Vitalsource acknowledgement received:',
    INVITE_EMAIL: 'Instructor Invite Email Ready to be Sent:',
    COMP_CODE_GENERATION: 'VitalSource  Comp Code status :',
    STUDENT_LINK:'Student Link'
};

export const MESSAGES = {
    default_success: "Your changes have been saved",
    default_failed: "Your changes were not saved",
    access_code_save_success: "Acccess Code Save Success",
    access_code_save_failed: "Acccess Code Save Failed",
    access_code_send_pcs_success: "Send Access Code To PDH Success",
    access_code_send_pcs_failed: "Send Access Code To PDH Failed",
    access_code_isbn_generate_success: "Access Code ISBN generated Successfully",
    access_code_isbn_generate_failed: "Access Code ISBN generation Failed",
    comp_code_isbn_generate_success: "Comp Code generated Successfully",
    comp_code_isbn_generate_failed: "Comp Code  generation Failed",
    course_contact_save_success : "Instructor Save Success",
    course_contact_save_failed : "Instructor Save Failed",
    institution_save_success : "Institution Save Success",
    institution_save_failed : "Institution Save Failed",
    order_details_save_success : "Order details save success",
    order_details_save_failed : "Save failed order details",
    part_delete_success: "Part Delete Success",
    part_delete_failed: "Part Delete Failed",
    resource_move_success: "Resource Move Success",
    resource_move_failed: "Resource Move Failed",
    resource_delete_success: "Resource Delete Success",
    resource_delete_failed: "Resource Delete Failed",
    send_to_pcs_success: "Send To PDH Success",
    send_to_pcs_failed: "Send To PDH Failed",
    book_rebuild_started: "Book rebuild started",
    unable_to_start_book_rebuild: "Unable to start book rebuild",
    book_already_send_to_build: "Error Collection Rebuild in progress. Please wait till the rebuild collection completes",
    book_has_both_om_and_3p: "Original Material (OM) and Third Party Material (3P) are included in this Collection.",
    book_has_om: "Original Material (OM) is included in this Collection.",
    book_has_3p: "Third Party Material (3P) is included in this Collection.",
    fail_message: "Error occurred. Please try again later.",
    upload_pdf_error: "Unable to add resource.",
    add_instructor_success: "Instructor added to course successfully",
    add_instructor_failed: "Failed to add instructor in course",
    instructor_exists_msg: "Instructor already associated to the course"
};

export const MESSAGE_TYPES = {
    default: {styleClass:'message_default',icon: false},
    error: {styleClass:'message_error',icon: 'warning-18'},
    warning: {styleClass:'message_warning',icon: 'warning-18'},
    success: {styleClass:'message_success',icon: 'check-lg-18'},
    info: {styleClass:'message_info',icon: false},
};

export const PERMISSIONS = {
    view_only_student_subcription_length : 'view_only_student_subcription_length',
    view_only_vitalsource_student_invite_link : 'view_only_vitalsource_student_invite_link',
    hide_vitalsource_log :   'hide_vitalsource_log',
    hide_vitalsource_invite_instructor : 'hide_vitalsource_invite_instructor',
    view_only_comp_code_button : 'view_only_comp_code_button',
    view_only_save_changes_button:'view_only_save_changes_button',
    view_only_rebuild_book_button:'view_only_rebuild_book_button',
    view_only_send_to_pdh:'view_only_send_to_pdh',
    view_only_view_pdf_log:'view_only_view_pdf_log',
    view_only_send_to_etext:'view_only_send_to_etext',
    view_only_send_to_vitalsource:'view_only_send_to_vitalsource',
    hide_etext_status_log:'hide_etext_status_log',
    hide_etext_invite_instructor: 'hide_etext_invite_instructor',
    view_only_etext_student_subcription_length:'view_only_etext_student_subcription_length',
    view_only_acess_code_ISBN_button:'view_only_acess_code_ISBN_button',
    view_only_SPWAccessCode:'view_only_SPWAccessCode',
    view_only_etext_access_code_student_length:'view_only_etext_access_code_student_length',
    view_only_send_access_code_to_pdh :' view_only_send_access_code_to_pdh',
    view_only_send_access_code_to_etext:'view_only_send_access_code_to_etext',
    view_only_collection_title: 'view_only_collection_title',    
    view_only_add_notes:'view_only_add_notes',
    view_only_toc_numeration : 'view_only_toc_numeration',
    view_only_forced_trim_size : 'view_only_forced_trim_size',
    view_only_automatic_page_numbering : ' view_only_automatic_page_numbering',
    view_only_automatic_indexes:'view_only_automatic_indexes',
    view_only_chapter_headers : 'view_only_chapter_headers',
    view_only_binding_type : 'view_only_binding_type',
    view_only_forced_recto_start : 'view_only_forced_recto_start',
    view_only_instructor_has_requested_access_codes : 'view_only_instructor_has_requested_access_codes',
    view_only_trim_size:'view_only_trim_size',
    view_only_pricing: 'view_only_pricing',
    view_only_org_unit: 'view_only_org_unit',
    view_only_course_name : 'view_only_course_name',
    view_only_course_number : 'view_only_course_number',
    view_only_estimated_enrollment : 'view_only_estimated_enrollment',
    view_only_class_startdate : 'view_only_class_startdate',
    view_only_class_enddate : 'view_only_class_enddate' ,
    view_only_draggable:'view_only_draggable',
    hide_adding_part: 'hide_adding_part',
    view_only_delete_chapter: 'view_only_delete_chapter',
    view_only_delete_part: 'view_only_delete_part',
    hide_add_content:'hide_add_content',
    hide_add_om:'hide_add_om',
    view_only_instructor_change:'view_only_instructor_change',
    view_only_institution_change:'view_only_institution_change',
    view_only_part_title: 'view_only_part_title',
    view_only_table_draggable: 'view_only_table_draggable',
    hide_only_pdflinks:'hide_only_pdflinks',
    view_only_cover_design:'view_only_cover_design',

};



// WEBPACK FOOTER //
// ./src/constants/APP_CONSTANTS.js